export const MIN_MONEY_WITHDRAW = 10000;
